/**
 * TRAD-3790 — 부수효과 전용 진입점. 🔴 main.tsx 의 **첫 번째 import** 여야 한다.
 * ESM 은 import 순서대로 하위 그래프를 끝까지 평가하므로, 이게 첫 줄이면 firebase(계측)·라우터가
 * 평가되기 «전»에 콜백 쿼리(code)가 주소창에서 사라진다. 순서는 테스트(main-import-order)로 고정.
 * 이 파일은 다른 앱 모듈을 import 하지 않는다(계측 모듈을 끌어오면 순서 보장이 깨진다).
 */
import { captureAppleAndroidCallback } from './apple-android-callback';

if (typeof window !== 'undefined') {
  captureAppleAndroidCallback({ location: window.location, history: window.history });
}
